<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="5">
            <label>专家姓名：</label>
            <a-input placeholder="请输入" v-model="queryName" class="query_input" />
          </a-col>
          <a-col :span="5">
            <label>单位：</label>
            <a-input placeholder="请输入" v-model="queryUnitName" class="query_input" />
          </a-col>
          <a-col :span="5">
            <label>审稿领域：</label>
            <a-select defaultValue="0" class="query_input" v-model="queryDomainCode">
              <a-select-option value="0">全部</a-select-option>
              <a-select-option v-for="item in domainTypes" :key="item.dicCode" :value="item.dicCode">{{
                item.dicValue
              }}</a-select-option>
            </a-select>
          </a-col>
          <a-button type="primary" class="query_btn" @click="query">查询</a-button>
          <a-button type="primary" style="margin-left: 10px" @click="() => addMethod('add')">新增</a-button>
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
      <div class="sortType" style="float: right">
        排序方式：
        <a-select size="small" defaultValue="1" style="width: 120px" @change="sortChange" v-model="sort">
          <a-select-option value="1">编号降序</a-select-option>
          <a-select-option value="2">编号升序</a-select-option>
          <a-select-option value="3">时间降序</a-select-option>
          <a-select-option value="4">时间升序</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="data"
          :rowKey="record => record.expertCode"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="operator" slot-scope="text, record">
            <a href="javascript:void(0);" @click="() => checkMethod(record, 'check')">查看</a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => editMethod(record, 'edit')">编辑</a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => changeStatus(record, '1')">启用</a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => changeStatus(record, '0')">禁用</a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => deleteMethod(record)">删除</a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => updatePwd(record)">重置密码</a>
          </span>
          <span slot="status" slot-scope="text, record">
            <label v-if="record.status == '1'">
              <img class="status_img" src="../../../../assets/open.png" />已启用
            </label>
            <label v-if="record.status == '0'">
              <img class="status_img" src="../../../../assets/close.png" />已禁用
            </label>
          </span>
        </a-table>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination
          :total="total"
          :showTotal="total => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
      <a-select defaultValue="0" class="batch_operation" @change="operateChange" v-model="operateCode">
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
        <a-select-option value="2">批量禁用</a-select-option>
        <a-select-option value="3">批量启用</a-select-option>
      </a-select>
    </div>
    <a-modal
      :title="title"
      v-model="visible"
      width="600px"
      @cancel="cancel"
      @ok="enSure"
      centered
      :maskClosable="false"
    >
      <template>
        <div class="expert-edit">
          <a-row v-if="isShow">
            <a-col :span="6" class="title"> <span style="color: red">*</span>专家编号： </a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="expertInfo.expertNum" v-bind:read-only="true" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span>专家姓名： </a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="expertInfo.name" v-bind:read-only="isEnable" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span>单位名称： </a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="expertInfo.unitName" v-bind:read-only="isEnable" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span>单位地址： </a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="expertInfo.unitAddress"
                v-bind:read-only="isEnable"
              />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span>联系电话： </a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="expertInfo.phone" v-bind:read-only="isEnable" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span> E-mail： </a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="expertInfo.eMail" v-bind:read-only="isEnable" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">审稿领域：</a-col>
            <a-col :span="12">
              <a-select
                mode="multiple"
                style="width: 100%"
                @change="dominChange"
                placeholder="请选择"
                v-model="expertInfo.domainCode"
                :disabled="isEnable"
              >
                <a-select-option v-for="item in domainTypes" :key="item.dicCode" :value="item.dicCode">{{
                  item.dicValue
                }}</a-select-option>
              </a-select>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">专业方向：</a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="expertInfo.mF" v-bind:read-only="isEnable" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">职务：</a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="expertInfo.job" v-bind:read-only="isEnable" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">职称：</a-col>
            <a-col :span="12">
              <a-input placeholder="请输入" class="input" v-model="expertInfo.title" v-bind:read-only="isEnable" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">性别：</a-col>
            <a-col :span="12">
              <a-radio-group v-model="value" @change="sexChange" :disabled="isEnable">
                <a-radio :value="1">男</a-radio>
                <a-radio :value="0">女</a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">出生年月：</a-col>
            <a-col :span="12">
              <a-month-picker :value="date" @change="dateChange" :disabled="isEnable" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">状态：</a-col>
            <a-col :span="8" id="status_checkbox">
              <a-checkbox :checked="isChecked" @change="statusChange" :disabled="isEnable">启用</a-checkbox>
            </a-col>
          </a-row>
        </div>
      </template>
    </a-modal>

    <a-modal title="查看" v-model="checkVisible" width="650px" :footer="null" centered :maskClosable="false">
      <template>
        <div class="expert-edit">
          <a-row v-if="isShow">
            <a-col :span="5" class="title"> 专家编号： </a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ expertInfo.expertNum }}
            </a-col>
            <a-col :span="5" class="title"> 专家姓名： </a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ expertInfo.name }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="title"> 单位名称： </a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ expertInfo.unitName }}
            </a-col>
            <a-col :span="5" class="title"> 单位地址： </a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ expertInfo.unitAddress }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="title"> 联系电话： </a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ expertInfo.phone }}
            </a-col>
            <a-col :span="5" class="title"> E-mail： </a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ expertInfo.eMail }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="title">审稿领域：</a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ expertInfo.domainStr }}
            </a-col>
            <a-col :span="5" class="title">专业方向：</a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ expertInfo.mF }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="title">职务：</a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ expertInfo.job }}
            </a-col>
            <a-col :span="5" class="title">职称：</a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ expertInfo.title }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="title">性别：</a-col>
            <a-col :span="6" style="margin-top: 5px">
              <label v-if="expertInfo.sex == 1">男</label>
              <label v-if="expertInfo.sex == 0">女</label>
            </a-col>
            <a-col :span="5" class="title">出生年月：</a-col>
            <a-col :span="6" style="margin-top: 5px">
              {{ expertInfo.boirth }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" class="title">状态：</a-col>
            <a-col :span="6" style="margin-top: 5px">
              <label v-if="expertInfo.status == '1'">启用</label>
              <label v-if="expertInfo.status == '0'">禁用</label>
            </a-col>
          </a-row>
        </div>
      </template>
    </a-modal>
    <a-modal title="提示" v-model="delVisible" @ok="deleteOk" :centered="true" width="300px" :maskClosable="false">
      <p>确认删除吗？</p>
    </a-modal>
    <a-modal
      title="密码重置"
      v-model="updatePwdVisible"
      @ok="updatePwdOk"
      :centered="true"
      width="300px"
      :maskClosable="false"
    >
      <p>您确定要为该用户进行密码重置？</p>
      <p>重置后密码将被设置为默认密码</p>
    </a-modal>
  </div>
</template>

<script>
import moment from "moment";
const columns = [
  {
    title: "专家帐号",
    dataIndex: "phone",
    width: 160,
  },
  {
    title: "专家姓名",
    dataIndex: "name",
    width: 140,
  },
  {
    title: "单位名称",
    dataIndex: "unitName",
  },
  {
    title: "审稿领域",
    width: "13%",
    dataIndex: "domainStr",
    key: "domainStr",
  },
  {
    title: "状态",
    width: 100,
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "创建者",
    width: 120,
    dataIndex: "creater",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
  },
  {
    title: "操作",
    width: 320,
    key: "operator",
    scopedSlots: { customRender: "operator" },
  },
];

const data = [];

import qs from "qs";
export default {
  name: "expert",
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      data,
      columns,
      selectedRowKeys: [],
      visible: false,
      checkVisible: false,
      expertInfo: {
        name: "",
        unitName: "",
        unitAddress: "",
        phone: "",
        eMail: "",
        sex: "1",
        status: "1",
        domainCode: [],
      },
      isChecked: true,
      date: null,
      oldPhone: "",
      isEnable: false,
      title: "",
      currentMode: "check",
      delVisible: false,
      updatePwdVisible: false,
      updatePwdUserName: "",
      queryName: "",
      queryUnitName: "",
      queryDomainCode: "0",
      sort: "1",
      domainTypes: [],
      sortField: "expert_num",
      sortType: "desc",
      userType: 3,
      operateCode: "0",
      isShow: true,
      value: 1,
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  created() {
    this.query();

    this.axios
      .get("/dataDic/queryChild", {
        params: {
          parentCode: "e5199efb-5fd8-45fe-a5dc-9100468e82b1",
          time: new Date().getTime(),
        },
        paramsSerializer: function (p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        },
      })
      .then(res => {
        this.domainTypes = res.data;
      });
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  methods: {
    moment,
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    sortChange() {
      if (this.sort == 1) {
        this.sortField = "expert_num";
        this.sortType = "desc";
      } else if (this.sort == 2) {
        this.sortField = "expert_num";
        this.sortType = "";
      } else if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      } else if (this.sort == 4) {
        this.sortField = "create_time";
        this.sortType = "";
      }
      this.query();
    },
    operateChange() {
      var itemLegth = this.selectedRowKeys.length;
      if (itemLegth == 0) {
        this.utils.messageInfo(this, "error", "最少选择一条数据！");
        return;
      }
      if (this.operateCode == 1) {
        if (this.serviceAddress == "") {
          this.utils.messageInfo(this, "error", "获取后台ip地址失败，无法导出！");
          return;
        }
        var selectedRowKeys = this.selectedRowKeys;
        window.open(this.serviceAddress + "/expertInfo/exportData?codeArr=" + selectedRowKeys + "");
      } else if (this.operateCode == 2) {
        this.batchChangeStatus("0");
      } else if (this.operateCode == 3) {
        this.batchChangeStatus("1");
      }
    },
    batchChangeStatus(status) {
      var phones = [];
      for (var i = 0; i < this.data.length; i++) {
        for (var j = 0; j < this.selectedRowKeys.length; j++) {
          if (this.selectedRowKeys[j] == this.data[i].expertCode) {
            phones.push(this.data[i].phone);
          }
        }
      }
      this.axios
        .post("/expertInfo/changeExpertStatus", {
          status: status,
          codes: JSON.stringify(this.selectedRowKeys),
          phones: JSON.stringify(phones),
        })
        .then(res => {
          if (res.data.code == "OK") {
            if (status == "0") {
              this.utils.messageInfo(this, "success", "禁用成功！");
            } else {
              this.utils.messageInfo(this, "success", "启用成功！");
            }
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "操作失败！");
          }
        });
    },
    statusChange(e) {
      if (e.target.checked) {
        this.isChecked = true;
        this.expertInfo.status = "1";
      } else {
        this.isChecked = false;
        this.expertInfo.status = "0";
      }
    },
    query() {
      this.axios
        .get("/expertInfo/queryExpertInfo", {
          params: {
            name: this.queryName,
            unitName: this.queryUnitName,
            domainCode: this.queryDomainCode,
            sortField: this.sortField,
            sortType: this.sortType,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then(res => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询专家列表失败！");
          }
        });
    },
    sexChange(e) {
      this.expertInfo.sex = e.target.value;
    },
    dominChange(value) {
      this.expertInfo.domainCode = value;
    },
    dateChange(date, dateString) {
      this.date = date;
      this.expertInfo.boirth = dateString;
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    addMethod(type) {
      this.expertInfo = {
        name: "",
        unitName: "",
        unitAddress: "",
        phone: "",
        eMail: "",
        sex: "1",
        status: "1",
        domainCode: [],
      };
      this.isEnable = false;
      this.visible = true;
      this.isShow = false;
      this.title = "新增";
      this.currentMode = type;
    },
    checkMethod(obj) {
      this.expertInfo = obj;
      this.checkVisible = true;
      this.isShow = true;
    },
    editMethod(obj, type) {
      var boirth = obj.boirth;
      this.date = null;
      if (boirth != undefined && boirth != "") {
        this.date = moment(boirth, "YYYY-MM");
      }
      if (obj.status == "1") {
        this.isChecked = true;
      } else {
        this.isChecked = false;
      }
      this.expertInfo = {
        expertCode: obj.expertCode,
        expertNum: obj.expertNum,
        name: obj.name,
        unitName: obj.unitName,
        unitAddress: obj.unitAddress,
        phone: obj.phone,
        eMail: obj.eMail,
        domainCode: obj.domainCode,
        mF: obj.mF,
        job: obj.job,
        title: obj.title,
      };

      this.oldPhone = obj.phone;
      this.isEnable = false;
      this.visible = true;
      this.isShow = true;
      this.title = "编辑";
      this.currentMode = type;
    },
    changeStatus(obj, status) {
      var codes = [];
      var phones = [];
      codes.push(obj.expertCode);
      phones.push(obj.phone);
      this.axios
        .post("/expertInfo/changeExpertStatus", {
          codes: JSON.stringify(codes),
          phones: JSON.stringify(phones),
          status: status,
        })
        .then(res => {
          if (res.data.code == "OK") {
            if (status == "0") {
              this.utils.messageInfo(this, "success", "禁用成功！");
            } else {
              this.utils.messageInfo(this, "success", "启用成功！");
            }
            for (var i = 0; i < this.data.length; i++) {
              if (this.data[i].expertCode == obj.expertCode) {
                this.data[i].status = status;
              }
            }
          } else {
            this.utils.messageInfo(this, "error", "编辑失败！");
          }
        });
    },
    deleteMethod(record) {
      this.delVisible = true;
      this.expertInfo = record;
    },
    deleteOk() {
      this.axios
        .post("/expertInfo/deleteExpertInfo", {
          expertCode: this.expertInfo.expertCode,
          phone: this.expertInfo.phone,
        })
        .then(res => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "删除成功");
            this.delVisible = false;
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "删除失败！");
          }
        });
    },
    cancel() {
      this.visible = false;
    },
    enSure() {
      if (this.currentMode == "check") {
        this.visible = false;
      } else if (this.currentMode == "edit") {
        if (this.expertInfo.expertNum == "") {
          this.utils.messageInfo(this, "error", "专家编号不能为空！");
          return;
        } else if (this.expertInfo.name == "") {
          this.utils.messageInfo(this, "error", "专家姓名不能为空！");
          return;
        } else if (this.expertInfo.unitName == "") {
          this.utils.messageInfo(this, "error", "单位名称不能为空！");
          return;
        } else if (this.expertInfo.unitAddress == "") {
          this.utils.messageInfo(this, "error", "单位地址不能为空！");
          return;
        } else if (this.expertInfo.phone == "") {
          this.utils.messageInfo(this, "error", "联系电话不能为空！");
          return;
        } else if (this.expertInfo.eMail == "") {
          this.utils.messageInfo(this, "error", "E-mail不能为空！");
          return;
        }
        if (!this.utils.isPhone(this.expertInfo.phone)) {
          this.utils.messageInfo(this, "error", "手机号格式不正确！");
          return;
        }
        if (!this.utils.isEmail(this.expertInfo.eMail)) {
          this.utils.messageInfo(this, "error", "邮箱格式不正确！");
          return;
        }
        this.axios
          .post("/expertInfo/updateExpertInfo", {
            expertCode: this.expertInfo.expertCode,
            expertNum: this.expertInfo.expertNum,
            name: this.expertInfo.name,
            unitName: this.expertInfo.unitName,
            unitAddress: this.expertInfo.unitAddress,
            phone: this.expertInfo.phone,
            eMail: this.expertInfo.eMail,
            domainCode: this.expertInfo.domainCode,
            mF: this.expertInfo.mF,
            job: this.expertInfo.job,
            title: this.expertInfo.title,
            sex: this.expertInfo.sex,
            boirth: this.expertInfo.boirth,
            status: this.expertInfo.status,
            oldPhone: this.oldPhone,
          })
          .then(res => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "编辑成功");
              this.query();
              this.visible = false;
            } else {
              this.utils.messageInfo(this, "error", res.data.data);
            }
          });
      } else if (this.currentMode == "add") {
        if (this.expertInfo.name == "") {
          this.utils.messageInfo(this, "error", "专家姓名不能为空！");
          return;
        } else if (this.expertInfo.unitName == "") {
          this.utils.messageInfo(this, "error", "单位名称不能为空！");
          return;
        } else if (this.expertInfo.unitAddress == "") {
          this.utils.messageInfo(this, "error", "单位地址不能为空！");
          return;
        } else if (this.expertInfo.phone == "") {
          this.utils.messageInfo(this, "error", "联系电话不能为空！");
          return;
        } else if (this.expertInfo.eMail == "") {
          this.utils.messageInfo(this, "error", "E-mail不能为空！");
          return;
        }
        if (!this.utils.isPhone(this.expertInfo.phone)) {
          this.utils.messageInfo(this, "error", "手机号格式不正确！");
          return;
        }
        if (!this.utils.isEmail(this.expertInfo.eMail)) {
          this.utils.messageInfo(this, "error", "邮箱格式不正确！");
          return;
        }
        this.axios
          .post("/expertInfo/saveExpertInfo", {
            name: this.expertInfo.name,
            unitName: this.expertInfo.unitName,
            unitAddress: this.expertInfo.unitAddress,
            phone: this.expertInfo.phone,
            eMail: this.expertInfo.eMail,
            domainCode: this.expertInfo.domainCode,
            mF: this.expertInfo.mF,
            job: this.expertInfo.job,
            title: this.expertInfo.title,
            sex: this.expertInfo.sex,
            boirth: this.expertInfo.boirth,
            status: this.expertInfo.status,
            creater: sessionStorage.getItem("userCode"),
          })
          .then(res => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "添加成功");
              this.query();
              this.visible = false;
            } else {
              this.utils.messageInfo(this, "error", res.data.data);
            }
          });
      }
    },
    updatePwd(data) {
      this.updatePwdUserName = data.phone;
      this.updatePwdVisible = true;
    },
    updatePwdOk() {
      this.axios
        .post("/systemUser/updateDefaultPwd", {
          userName: this.updatePwdUserName,
          newPwd: "Bianji@123456",
        })
        .then(res => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "重置密码成功！");
            this.query();
          } else {
            this.utils.messageInfo(this, "error", res.data.data);
          }
        });
      this.updatePwdVisible = false;
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
.expert-edit .ant-row {
  margin-bottom: 10px;
}
.expert-edit .title {
  text-align: right;
  line-height: 32px;
}
#status_checkbox {
  margin-top: 5px;
}
.status_img {
  width: 18px;
  margin-right: 6px;
  margin-bottom: 3px;
}
</style>
